import { usePageFilterSaver } from 'hooks/usePageFilterSaver';

import { useCallback, useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export const useResetWorkOrderFiltersWithStructureOps = () => {
    const { pathname } = useLocation();
    const { handleGetMemoizedValues, handleCleanEntityMemoizedValues } = usePageFilterSaver({});

    // reset work order store values if excluded/removed saved id
    const makeResetWorkOrderObjectFilter = useCallback(
        (processedIds: number[] | null | undefined) => {
            if (!Array.isArray(processedIds)) {
                return;
            }

            const pathKey = pathname.replace('/structure', '');

            const memoizedValues = handleGetMemoizedValues({ pathNameKey: pathKey });

            if (memoizedValues) {
                const currentSavedConstructionTypeId = memoizedValues.constructionTypeId;
                const currentSavedObjectId = memoizedValues?.[currentSavedConstructionTypeId]?.object?.id;

                if (currentSavedObjectId) {
                    if (processedIds.includes(currentSavedObjectId)) {
                        handleCleanEntityMemoizedValues({
                            pathNameKey: pathKey,
                        });
                    }
                }
            }
        },
        [handleCleanEntityMemoizedValues, handleGetMemoizedValues, pathname],
    );

    return useMemo(
        () => ({
            makeResetWorkOrderObjectFilter,
        }),
        [makeResetWorkOrderObjectFilter],
    );
};
